const loupeIcon = `
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>Line_Icons</title>
    <desc>Created with Sketch.</desc>
    <g id="Dashboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Dashboard" transform="translate(-649.000000, -1143.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <g id="Latest-photos" transform="translate(316.000000, 1045.000000)">
                <g id="Photo-Copy" transform="translate(233.000000, 40.000000)">
                    <g id="zoom-in.1" transform="translate(98.000000, 56.000000)">
                        <g id="Line_Icons" transform="translate(2.000000, 2.000000)">
                            <g id="Group">
                                <polygon id="Path" points="9 4 7 4 7 7 4 7 4 9 7 9 7 12 9 12 9 9 12 9 12 7 9 7"></polygon>
                                <path d="M19.707,18.293 L14.314,12.9 C15.403,11.504 16,9.799 16,8 C16,5.863 15.167,3.854 13.656,2.344 C12.146,0.832 10.137,0 8,0 C5.863,0 3.854,0.832 2.344,2.344 C0.833,3.854 0,5.863 0,8 C0,10.137 0.833,12.146 2.344,13.656 C3.854,15.168 5.863,16 8,16 C9.799,16 11.504,15.404 12.9,14.314 L18.293,19.706 L19.707,18.293 Z M8,14 C6.397,14 4.891,13.376 3.758,12.243 C2.624,11.11 2,9.603 2,8 C2,6.398 2.624,4.891 3.758,3.758 C4.891,2.624 6.397,2 8,2 C9.603,2 11.109,2.624 12.242,3.758 C13.376,4.891 14,6.398 14,8 C14,9.603 13.376,11.11 12.242,12.243 C11.109,13.376 9.603,14 8,14 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default loupeIcon;
